import type { QnaQuestionPageView } from "@buildpy/core/views/g5a/qna";

import QnaQuestion from "@/modules/process-standard/ui/qna-question";
import StandardsShell from "@/modules/process-standard/ui/standards-shell";

// Q&A 질문 하나 — 답변·신고.
const Page = ({ data }: { data: QnaQuestionPageView }) => (
  <StandardsShell tab="qna">
    <QnaQuestion data={data} />
  </StandardsShell>
);

export default Page;
